<app-spinner [show]="showSpinner"></app-spinner>
<!-- Start Page Title Area -->
<div class="page-title-area item-bg1 jarallax" data-jarallax='{"speed": 0.3}'>
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">{{home}}</a></li>
                <li>{{myAccount}}</li>
            </ul>
            <h2>{{myAccount}}</h2>
        </div>
    </div>
</div>
<!-- End Page Title Area -->
<!-- Start My Account Area -->
<section class="my-account-area ptb-100">
    <div class="container">
        <div class="myAccount-profile">
            <div class="row align-items-center">
                <div class="col-lg-2 col-md-3">
                    <div class="profile-image">
                        <img src="{{photoUrl}}" alt="image">
                    </div>
                </div>

                <div class="col-lg-10 col-md-9">
                    <div class="profile-content">
                        <h3>{{user.displayName}}</h3>
                        <ul class="contact-info">
                            <li><i class='bx bx-envelope'></i> <a href="#">{{user.email}}</a></li>
                        </ul>
                        <div class="buttons" *ngIf="hasImage; else elseBlock">
                          
                            <a href="javascript:;" (click)= "onRemoveImage()" class="myAccount-logout">{{removeImage}}</a>
                            <a href="javascript:;" (click)= "onLogout()" class="myAccount-logout">{{logout}}</a>
                        </div>

                        <ng-template #elseBlock>
                            <div class="buttons">
                                <a href="javascript:;" (click)= "onAddImage()" class="myAccount-logout">{{addImage}}</a>
                                <a href="javascript:;" (click)= "onLogout()" class="myAccount-logout">{{logout}}</a>
                            </div>
                        </ng-template>
                        
                    </div>
                </div>
            </div>
        </div>

        <div class="myAccount-navigation">
            <ul>
                <li *ngFor="let item of items" ><a (click)="onItemClicked(item)" class="active" [ngClass]="{active:item.isActive}"><i [ngClass]="['bx', item.iconClassName]"></i> {{item.title}}</a></li>
            </ul>
        </div>

        <router-outlet></router-outlet>
        
    </div>
</section>
<!-- End My Account Area -->

